import { Navigate } from "react-router-dom";
import { PATH_AUTH } from "src/routes/paths";

const ForgotPassword = () => <Navigate to={PATH_AUTH.signIn} replace />;
export default ForgotPassword;
